// Petits helpers DOM partagés par les écrans (dédup Phase 6).

/** Fabrique un accesseur typé aux éléments d'index.html pour un écran donné : lève une erreur
 *  SITUANT l'écran (`where`) si l'élément est absent (utile au debug si le HTML change). Chaque
 *  écran fait `const byId = mkById('Nom de l'écran')` puis `byId<HTMLXxx>('id')` comme avant. */
export function mkById(where: string) {
  return <E extends HTMLElement>(id: string): E => {
    const el = document.getElementById(id)
    if (!el) throw new Error(`${where} : élément #${id} introuvable dans index.html`)
    return el as E
  }
}

/** Message d'erreur affichable à partir d'une exception inconnue. */
export const errText = (e: unknown): string => (e instanceof Error && e.message ? e.message : 'Une erreur est survenue. Réessaie.')
